import type { CustomFlowbiteTheme } from 'flowbite-react';

export const tabsTheme: CustomFlowbiteTheme['tabs'] = {
  base: 'flex flex-col gap-2',
  tablist: {
    base: 'flex text-center',
    variant: {
      default: 'flex-wrap border-b border-titan-night-200',
      underline: '-mb-px flex-wrap border-b border-titan-night-200',
      pills: 'flex-wrap space-x-2 text-sm font-medium text-titan-night-500',
      fullWidth:
        'grid w-full grid-flow-col divide-x divide-titan-night-200 rounded-none text-sm font-medium shadow',
    },
    tabitem: {
      base: 'flex items-center justify-center rounded-t-lg p-4 text-sm font-medium first:ml-0 focus:ring-2 focus:ring-black disabled:cursor-not-allowed disabled:text-titan-night-400',
      variant: {
        default: {
          base: 'rounded-t-lg',
          active: {
            on: 'bg-gray-100',
            off: 'text-titan-night-500 hover:bg-titan-night-50 hover:text-titan-night-600',
          },
        },
        underline: {
          base: 'rounded-t-lg',
          active: {
            on: 'active rounded-t-lg border-b-2 border-titan-folly-600 text-titan-folly-600',
            off: 'border-b-2 border-transparent text-titan-night-500 hover:border-titan-night-300 hover:text-titan-night-600',
          },
        },
        pills: {
          base: '',
          active: {
            on: 'rounded-lg bg-titan-folly-600 text-white',
            off: 'rounded-lg hover:bg-titan-night-100 hover:text-titan-night-900',
          },
        },
        fullWidth: {
          base: 'ml-0 flex w-full rounded-none first:ml-0',
          active: {
            on: 'active rounded-none bg-titan-night-100 p-4 text-titan-night-900',
            off: 'rounded-none bg-white hover:bg-titan-night-50 hover:text-titan-night-700',
          },
        },
      },
      icon: 'mr-2 h-5 w-5',
    },
  },
  tabitemcontainer: {
    base: '',
    variant: {
      default: '',
      underline: '',
      pills: '',
      fullWidth: '',
    },
  },
  tabpanel: 'py-3',
};
